import authApi from '../clients/auth';

import { OrganizationLanguage } from '@/features/settings/api/types/gdpr';

export const resetPassword = async (email: string, language: OrganizationLanguage) => {
  await authApi.post('/password-reset', {
    email,
    language,
    // We set that to distinct admin and reception panel, because they use the same endpoint and we need to send email with correct link
    origin: 'web',
  });
};

export const setPassword = async (token: string, password: string) => {
  await authApi.post('/password-reset/set-password', {
    password,
    token,
  });
};

export const fetchResetPasswordExpiration = async (token: string): Promise<boolean> => {
  const { data } = await authApi.get<boolean>('/password-reset/check-validity', {
    params: { token },
  });

  return data;
};
